import reduce from 'ramda/src/reduce';

const sum = (reports) => {
  const reduceFunction = (acc, value) => {
    acc.paidViaSquireAmount += value.paidViaSquireAmount;
    acc.paidViaSquireCount += value.paidViaSquireCount;
    acc.paidInShopViaPosAmount += value.paidInShopViaPosAmount;
    acc.paidInShopOtherAmount += value.paidInShopOtherAmount;
    acc.paidInShopViaPosCount += value.paidInShopViaPosCount;
    acc.paidInShopOtherCount += value.paidInShopOtherCount;
    acc.paidViaGiftCardAmount += value.paidViaGiftCardAmount;
    acc.tipAmount += value.tipAmount;
    acc.tipCount += value.tipCount;
    acc.taxAmount += value.taxAmount;
    acc.canceledAmount += value.canceledAmount;
    acc.canceledAppointmentCount += value.canceledAppointmentCount;
    acc.noShowAmount += value.noShowAmount;
    acc.noShowAppointmentCount += value.noShowAppointmentCount;
    acc.totalAmount += value.total;
    acc.totalCount += value.paidInShopViaPosCount + value.paidInShopOtherCount + value.paidViaSquireCount;
    acc.discountCount += value.discountCount;
    acc.discountAmount += value.discount;
    acc.promoAmount += value.promo;
    acc.totalDiscount += (value.discount + value.promo);
    acc.giftCardSold += value.giftCardSold;
    acc.squireTipAmount += value.squireTipAmount;
    acc.squireTipCount += value.squireTipCount;
    acc.posTipAmount += value.posTipAmount;
    acc.posTipCount += value.posTipCount;
    acc.cashTipAmount += value.cashTipAmount;
    acc.cashTipCount += value.cashTipCount;
    acc.giftCardTipAmount += value.giftCardTipAmount;
    acc.giftCardTipCount += value.giftCardTipCount;
    acc.paidViaGiftCardCount += value.paidViaGiftCardCount;
    acc.fee += value.fee;
    acc.grossRevenue += value.grossRevenue;

    return acc;
  };
  const acc = {
    paidViaSquireAmount: 0,
    paidViaSquireCount: 0,
    paidInShopViaPosAmount: 0,
    paidInShopOtherAmount: 0,
    paidInShopViaPosCount: 0,
    paidInShopOtherCount: 0,
    tipAmount: 0,
    tipCount: 0,
    taxAmount: 0,
    canceledAmount: 0,
    canceledAppointmentCount: 0,
    noShowAmount: 0,
    noShowAppointmentCount: 0,
    totalAmount: 0,
    totalCount: 0,
    discountCount: 0,
    discountAmount: 0,
    promoAmount: 0,
    totalDiscount: 0,
    paidViaGiftCardAmount: 0,
    giftCardSold: 0,
    squireTipAmount: 0,
    squireTipCount: 0,
    posTipAmount: 0,
    posTipCount: 0,
    cashTipAmount: 0,
    cashTipCount: 0,
    giftCardTipAmount: 0,
    giftCardTipCount: 0,
    paidViaGiftCardCount: 0,
    fee: 0,
    grossRevenue: 0,
  };
  return reduce(reduceFunction, acc, reports);
};

export default sum;
